import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[rtHeading]',
    standalone: false
})
export class RtHeadingDirective {
  @HostBinding('class') classes = 'rt-heading';
}
